import { formatAboBV } from "../../../../components/Lit/acc-mixins/l10n.js";
import { storedLocale, marketCode } from "../../../../components/Authentication/util";

type Props = {
  bv: number;
};

export const LeafBV = (props: Props) => {
  const { bv } = props;
  const locale = storedLocale();
  const market = marketCode();

  return <>{formatAboBV(bv, locale, market)}</>;
};
